"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpressionViewItems = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ExpressionPreview_1 = require("../../components/ExpressionEditor/ExpressionPreview");
const Tag_1 = require("../../components/Tag");
const getExpressionViewItems = (query, api) => {
    // const expressionText = api.internalApi.getAdaptableQueryExpressionText(query);
    return {
        name: 'Expression',
        // values: [],
        view: (React.createElement(Tag_1.Tag, null,
            React.createElement(ExpressionPreview_1.ExpressionPreview, { query: query }))),
    };
};
exports.getExpressionViewItems = getExpressionViewItems;
